module.exports = __webpack_public_path__ + "img/insta.fc2efb5b.png";